// extracted by mini-css-extract-plugin
module.exports = {"alarm_close":"modal_alarm_close__KZXec","alarm_modal":"modal_alarm_modal__1wVT8","alarm_modal_lg":"modal_alarm_modal_lg__5nvMY","alarm_modal_bg":"modal_alarm_modal_bg__1ldAn"};